import { render, staticRenderFns } from "./paike.vue?vue&type=template&id=6d6d26a8&scoped=true&"
import script from "./paike.vue?vue&type=script&lang=ts&"
export * from "./paike.vue?vue&type=script&lang=ts&"
import style0 from "./paike.vue?vue&type=style&index=0&id=6d6d26a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6d26a8",
  null
  
)

export default component.exports